import http from '@/http'
import { StationMode } from '@/modules/check-in/service/fetchAttendeeList'

export type Counts = {
  total: number
  aguardando: number
  done: number
}

/**
 * Contadores das abas por modo (Todos / Aguardando / concluídos).
 * Respeita a busca; no modo brinde, respeita a tag da estação.
 */
export async function fetchCounts (
  mode: StationMode,
  search: string | null,
  brindeTagId: number | null
): Promise<Counts> {
  const params: { [k: string]: string | number } = { mode }
  if (search) params.search = search
  if (mode === 'brinde' && brindeTagId) {
    // eslint-disable-next-line camelcase
    params.brinde_tag_id = brindeTagId
  }

  const response = await http.get('/admin/check-in/counts', {
    params,
    validateStatus: () => true
  })

  if (response.status === 200 && response.data) {
    return {
      total: Number(response.data.total) || 0,
      aguardando: Number(response.data.aguardando) || 0,
      done: Number(response.data.done) || 0
    }
  }
  return { total: 0, aguardando: 0, done: 0 }
}
